export default "__VITE_ASSET___idluU2G__"